import { BankAccount } from '@liveauctioneers/caterwaul-components/types/BankAccount';
import { TypedActionWithPayload } from '@/types/redux';

export const LOAD_BANK_ACCOUNTS_FAIL = 'LOAD_BANK_ACCOUNTS_FAIL';
export type LOAD_BANK_ACCOUNTS_FAIL_ACTION = TypedActionWithPayload<typeof LOAD_BANK_ACCOUNTS_FAIL, string>;

export const LOAD_BANK_ACCOUNTS_REQUEST = 'LOAD_BANK_ACCOUNTS_REQUEST';
export type LOAD_BANK_ACCOUNTS_REQUEST_ACTION = TypedActionWithPayload<typeof LOAD_BANK_ACCOUNTS_REQUEST>;

export const LOAD_BANK_ACCOUNTS_SUCCESS = 'LOAD_BANK_ACCOUNTS_SUCCESS';
export type LOAD_BANK_ACCOUNTS_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_BANK_ACCOUNTS_SUCCESS,
    BankAccount[]
>;

export const POST_BANK_ACCOUNT_FAIL = 'POST_BANK_ACCOUNT_FAIL';
export type POST_BANK_ACCOUNT_FAIL_ACTION = TypedActionWithPayload<typeof POST_BANK_ACCOUNT_FAIL, string>;

export const POST_BANK_ACCOUNT_REQUEST = 'POST_BANK_ACCOUNT_REQUEST';
export type POST_BANK_ACCOUNT_REQUEST_ACTION = TypedActionWithPayload<typeof POST_BANK_ACCOUNT_REQUEST>;

export const POST_BANK_ACCOUNT_SUCCESS = 'POST_BANK_ACCOUNT_SUCCESS';
export type POST_BANK_ACCOUNT_SUCCESS_ACTION = TypedActionWithPayload<typeof POST_BANK_ACCOUNT_SUCCESS, BankAccount>;

export const DELETE_BANK_ACCOUNT_FAIL = 'DELETE_BANK_ACCOUNT_FAIL';
export type DELETE_BANK_ACCOUNT_FAIL_ACTION = TypedActionWithPayload<typeof DELETE_BANK_ACCOUNT_FAIL, string>;

export const DELETE_BANK_ACCOUNT_REQUEST = 'DELETE_BANK_ACCOUNT_REQUEST';
export type DELETE_BANK_ACCOUNT_REQUEST_ACTION = TypedActionWithPayload<typeof DELETE_BANK_ACCOUNT_REQUEST>;

export const DELETE_BANK_ACCOUNT_SUCCESS = 'DELETE_BANK_ACCOUNT_SUCCESS';
export type DELETE_BANK_ACCOUNT_SUCCESS_ACTION = TypedActionWithPayload<typeof DELETE_BANK_ACCOUNT_SUCCESS>;
